<template>
    <landlords-store
        v-slot="{
            sid,
            error,
            is_loading,
            has_loaded,
            store
        }"
        @success="onLandlordsStoreSuccess"
        @error="onLandlordsStoreError"
    >
        <with-variables
            :variables="{
                is_saving: has_loaded || is_loading
            }"
            v-slot="{
                is_saving
            }"
        >
            <base-form
                @submit="store(_.extend(form, {
                    intended: $route.query.intended
                }))"
            >
                <div class="px-6 pt-6 border-b">
                    <validator-alert :sid="sid" />

                    <base-alert
                        v-if="!_.preload('app.beta.allow-landlords')"
                        level="warning"
                    >
                        <template slot="heading">Paused landlord creation</template>

                        <template slot="content">
                            We've placed a temporary pause on creating new landlords accounts. Apologies for the inconvenience.
                        </template>
                    </base-alert>

                    <h1 class="mb-6 text-lg font-normal text-center">
                        Create a <strong>landlord</strong> profile
                    </h1>

                    <form-item
                        :sid="sid"
                        :is-required="true"
                        name="first_name"
                    >
                        <template slot="label">First name</template>

                        <input-text
                            v-model="form.first_name"
                            :sid="sid"
                            :autofocus="true"
                            :disabled="is_saving"
                            name="first_name"
                        />
                    </form-item>

                    <form-item
                        :sid="sid"
                        :is-required="true"
                        name="last_name"
                    >
                        <template slot="label">Last name</template>

                        <input-text
                            v-model="form.last_name"
                            :sid="sid"
                            :disabled="is_saving"
                            name="last_name"
                        />
                    </form-item>
                </div>

                <div class="px-6 py-3 text-right rounded-b bg-grey-bg">
                    <base-button
                        :is-loading="is_saving"
                        class="w-full btn-blue"
                        :disabled="!_.preload('app.beta.allow-landlords')"
                    >
                        Create Profile
                    </base-button>

                    <div class="pt-3 text-xs leading-tight text-center">
                        By creating a profile, you agree to
                        <a
                            href="https://stripe.com/gb/connect-account/legal"
                            class="no-underline text-blue"
                        >
                            Stripe's Connected Account Agreement.
                        </a>
                    </div>
                </div>

                <error-modal
                    v-if="error && $error.is(error, { exclude: [400, 422] })"
                    :error="error"
                />
            </base-form>
        </with-variables>
    </landlords-store>
</template>

<script>
    import scroll from '../../../support/scroll'
    import HeadMixin from '../../../mixins/head'
    import LandlordsStore from '../../../components/landlords-store'

    export default {
        mixins: [
            HeadMixin
        ],
        components: {
            LandlordsStore
        },
        data () {
            return {
                form: {
                    first_name: '',
                    last_name: ''
                }
            }
        },
        methods: {
            head () {
                return {
                    title: 'Create a landlord profile'
                }
            },
            onLandlordsStoreSuccess ({ meta }) {
                this.$track(
                    'auth.landlords.create',
                    'form-submission',
                    'A user has created a landlord persona'
                )

                setTimeout(() => {
                    window.location = meta.redirect
                }, 0)
            },
            onLandlordsStoreError () {
                scroll.toTop()
            }
        }
    }
</script>
